const style = {
	height: 0,
	width: 0,
	fontSize: 0,
	margin: 0,
	opacity: 0
};

export default function HiddenLabel({ labelFor, block = {} }) {
	const ariaLabel =
		['radio', 'checkbox', 'select'].indexOf(block.typeName) > -1
			? block?.properties?.elements_extra?.[1]?.placeholder ?? 'please specify'
			: block?.typeName === 'contact'
			? block?.placeholder
			: 'input field';

	return (
		<label
			style={style}
			for={labelFor}
			ariaLabel={ariaLabel}
		>
			{block.properties?.placeholder}
		</label>
	);
}
